module.exports = __webpack_public_path__ + "static/9y-logo-adf3e739fff76950dbbcbe014591a046.png";